import { useEffect } from 'react';
import useCallbackRef from 'hooks/useCallbackRef';
export default function useTimeout(callback, delay) {
  var fnRef = useCallbackRef(callback);
  useEffect(function () {
    var idx = setTimeout(fnRef.current, delay);
    return function () {
      return clearTimeout(idx);
    };
  }, [delay, fnRef]);
}